// extracted by mini-css-extract-plugin
export var hideEditor = "_n2-2";
export var infoIcon = "_n2-3";
export var label = "_n2-1";
export var labelContainer = "_n2-0";
export var readonlyText = "_n2-4";